const YearState: string[] = [];

export default YearState;